import type { NotificationFormType } from '@/notificationForms'
import type { TestValues } from '../types'

import { useConfigureController } from '../hooks/useController'

import { ModalContent } from '@/components/Modal'
import { Body } from './Body'
import { Footer } from './Footer'
import { Header } from './Header'

interface Props {
  notification: NotificationFormType
  values: TestValues
}

export function Content(props: Props) {
  const { notification, values } = props
  const { ready } = useConfigureController(notification, values)

  if (!ready) return null

  return (
    <ModalContent header={<Header />} footer={<Footer />}>
      <Body />
    </ModalContent>
  )
}
